<template>
  <div>
    <h1 class="header-style">
      Active Check-in
    </h1>
    <br>
    <p class="subheader-style">
      Currrent active check-in details.
    </p>
    <div class="check-in-clock-style">
      <check-in-clock />
    </div>
    <div class="check-out-btn">
      <v-btn
        v-if="anyCheckInAvailable"
        class="view-all-btn mt-3"
        elevation="0"
        x-small
        @click="toCheckOut()"
      >
        Check-out <v-icon x-small>
          mdi-arrow-top-right
        </v-icon>
      </v-btn>
    </div>
    <br>
    <br>
    <div v-if="anyCheckInAvailable">
      <v-card
        color="#E2E2E2"
        elevation="0"
      >
        <v-card-text>
          <p class="title-text-style">
            Project Name: <font class="value-text-style">
              {{ userCurrentCheckInDetails.project.name }}
            </font>
          </p>
          <p class="title-text-style">
            Check-in Type: <font class="value-text-style">
              {{ userCurrentCheckInDetails.type | arrangePretty }}
            </font>
          </p>
          <p class="title-text-style">
            Check-in Gate: <font
              v-if="userCurrentCheckInDetails.checkin_kiosk !== null"
              class="value-text-style"
            >
              {{ userCurrentCheckInDetails.checkin_kiosk.location_name }} [Kiosk]
            </font>
            <font v-if="userCurrentCheckInDetails.checkin_kiosk === null && userCurrentCheckInDetails.checkin_method_type !== 'cost-shift'">
              {{ userCurrentCheckInDetails.checkin_gate.name }}
            </font>
            <font v-if="userCurrentCheckInDetails.checkin_kiosk === null && userCurrentCheckInDetails.checkin_method_type === 'cost-shift'">
              N/A
            </font>
          </p>
          <p class="title-text-style">
            Check-in Time: <font class="value-text-style">
              {{ userCurrentCheckInDetails.checkin_time | convertToLocal }}
            </font>
            <font
              v-if="userCurrentCheckInDetails.checkin_method_type === 'cost-shift'"
              class="value-text-style"
            >
              [Cost-Shift]
            </font>
          </p>
          <p class="title-text-style">
            Check-out Time:
            <font
              v-if="userCurrentCheckInDetails.checkout_time !== null"
              class="value-text-style"
            >
              {{ userCurrentCheckInDetails.checkout_time | convertToLocal }}
            </font>
            <font class="value-text-style">
              N/A
            </font>
          </p>
        </v-card-text>
      </v-card>
      <br>
      <br>
      <br>
    </div>

    <div
      v-else
      class="empty-alert-div"
    >
      <v-card
        color="#E2E2E2"
        elevation="0"
      >
        <br>
        <br>
        <p class="empty-alert-msg">
          <v-icon
            size="25"
            color="#C62828"
          >
            mdi-information-outline
          </v-icon>
          No records found
        </p>
        <br>
        <br>
      </v-card>
    </div>
    <centre-spinner
      :loading="loading"
    />
  </div>
</template>

<script>
import spinner from '../../components/SpinnerCentre.vue';
import moment from 'moment';
import CheckInClock from './CheckInClock.vue';
import Constants from 'src/constants';

export default {
  name: 'ActiveCheckInsPage',
  components: {
    'centre-spinner': spinner,
    'check-in-clock': CheckInClock,
  },
  filters: {
    convertToLocal (stringDatetime) {
      return moment(stringDatetime).local().format('Do MMMM YYYY hh:mm A');
    },
    arrangePretty (val) {
      if (val === 'staff') {
        return 'Site Manager';
      } else {
        return val;
      }
    },
  },
  data: () => ({
    loading: false,
  }),
  computed: {
    userCurrentCheckInDetails () {
      return this.$store.getters['swiftuser/getActiveCheckInDetails'];
    },
    anyCheckInAvailable () {
      if (Object.keys(this.userCurrentCheckInDetails).length !== 0) {
        return true;
      }
      return false;
    },
  },
  async mounted () {
    this.loading = true;
    await this.getUserCurrentCheckInDetails();
    this.loading = false;
  },
  methods: {
    getUserCurrentCheckInDetails () {
      this.$store.dispatch('swiftuser/fetchUsersCurrentCheckInDetails');
    },
    toCheckOut () {
      if (this.anyCheckInAvailable === false) {
        this.$store.dispatch('alert/onAlert', {
          message: 'No check-in records found.',
          type: Constants.ALERT_TYPE_ERROR,
        }, { root: true });
        return;
      }
      this.$router.push({ name: 'CheckOut' });
    },
  },
};
</script>

<style scoped>
.check-in-clock-style {
  padding-top: 35px;
  padding-bottom: 35px;
  border: 1px solid #37474F;
  border-radius: 15px !important;
  overflow: hidden;
  z-index: 1;
  text-align: center;
}
.check-out-btn {
  float: right;
}
</style>
